<template>
  <div v-style="{ bg: backgroundColor, py: paddingsMapping }">
    <div v-style:b="borderColor" :class="{ 'b-b': bottomDivider, 'container': !isFullWidth }">
      <h2
        v-if="title"
        v-style:c="titleColor"
        v-html="title"
        class="mb-4"
        :class="[titleStyle, { 'px-4': !style }]"
      />
      <vf-accordion
        v-for="(accordion, i) in accordions"
        :key="i"
        :border-color
        :icon="iconsStyle"
        :icon-collapse="iconsMap[iconsStyle]"
        :title="accordion.title"
        :title-color
        :variant="style"
      >
        <div class="pb-3 ">
          <lazy-cms-rich-text :content="{ richText: accordion.richText }" />
        </div>
      </vf-accordion>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AccordionsContent } from '#types/components/cms/accordions'
import type { ResponsiveColor } from '#types/content'

const { content } = defineProps<{ content: AccordionsContent }>()
const {
  accordions,
  backgroundColor,
  bottomDivider,
  iconsStyle = 'chevron',
  isFullWidth,
  paddings,
  style,
  title,
  titleColor,
  titleStyle,
} = content

const { ds: { breakpoints, colors }, components: { cms } } = useAppConfig()
const { componentSpacingMap } = cms.section

const borderColor = Object.keys(breakpoints).reduce((acc, cur) => {
  const valueForBreakpoint = getValueForBreakpoint(cur as keyof ResponsiveColor, titleColor)
  if (valueForBreakpoint?.toLowerCase() !== colors.grey[10]) acc[cur] = valueForBreakpoint
  else acc[cur] = colors.grey[70]
  return acc
}, {} as ResponsiveColor)

const iconsMap = {
  plus: 'minus',
}

const paddingsMapping = Object.keys(breakpoints).reduce((acc, bp) => ({
  ...acc,
  [bp]: componentSpacingMap[paddings?.[bp]]
}), {})
</script>
